(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gh-accordian-with-image"] && !Shopify.designMode) return;
  try {
    

  document.querySelectorAll('.accordian-container .question').forEach(function (question) {
      question.addEventListener('click', function () {
          // Remove 'active' class from all 'question' elements
          document.querySelectorAll('.accordian-container .active').forEach(function (activeQuestion) {
              activeQuestion.classList.remove('active');
          });
          this.parentNode.classList.add('active');
          var id = this.parentNode.getAttribute('data-id');
          document.querySelectorAll('.accordian-image img').forEach(function (activeImage) {
              activeImage.classList.remove('active');
          });
          var targetImages = document.querySelectorAll('.accordian-image .' + id);
          targetImages.forEach(function (targetImage) {
              targetImage.classList.add('active');
          });

      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gh-community"] && !Shopify.designMode) return;
  try {
    


  function waitForSwiper(trigger) {
    var interval = setInterval(function() {
      if (typeof Swiper != 'undefined') {
        clearInterval(interval);
        trigger();
      }
    })
    setTimeout(function() {
      clearInterval(interval);
    }, 15000)
  }


  function communitySlider() {
    var swiper = new Swiper('.logos.swiper-container', {
      slidesPerView: 3.5,
      spaceBetween: 40,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {

        768: {
          slidesPerView: 8,
          spaceBetween: 24
        }

      }
    });
  }
  waitForSwiper(function() {
    communitySlider();
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gh-icon-with-text-slider"] && !Shopify.designMode) return;
  try {
    


  function waitForSwiper(trigger) {
    var interval = setInterval(function() {
      if (typeof Swiper != 'undefined') {
        clearInterval(interval);
        trigger();
      }
    })
    setTimeout(function() {
      clearInterval(interval);
    }, 15000)
  }


  function communitySlider() {
    var swiper = new Swiper('.icon-with-text-slider.swiper-container', {
      slidesPerView: 2.5,
      spaceBetween: 32,
      loop: true,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {

        768: {
          slidesPerView: 5,
          spaceBetween: 50,
          loop: false,
          centeredSlides: false
        }

      }
    });
  }
  waitForSwiper(function() {
    communitySlider();
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gh-let-customers-speak"] && !Shopify.designMode) return;
  try {
    

  function waitForSwiper(trigger) {
    var interval = setInterval(function() {
      if (typeof window.Swiper != 'undefined') {
        clearInterval(interval);
        trigger();
      }
    }, 50);
    setTimeout(function() {
      clearInterval(interval);
    }, 15000);
  }

  waitForSwiper(function() {
    var swiper = new Swiper('.let-customers-speak .swiper-container', {

      // Optional parameters
      direction: 'vartical',
      spaceBetween: 20,
      slidesPerView: 2,

      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        1200: {
          direction: 'vartical',
          spaceBetween: 20,
          slidesPerView: 2,

// autoHeight: true,
          watchSlidesVisibility: true
        },
        991: {
          direction: 'vartical',
          spaceBetween: 20,
          slidesPerView: 2,
          watchSlidesVisibility: true,

          initialSlide: 1
        },
        0: {
          direction: 'vartical',
          slidesPerView: 2,
          spaceBetween: 20,
          initialSlide: 1
        }
      }
    });
  })
  window.dispatchEvent(new Event('resize'));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
